import { render, staticRenderFns } from "./ReportedPost.vue?vue&type=template&id=f6c7639c&scoped=true&"
import script from "./ReportedPost.vue?vue&type=script&lang=js&"
export * from "./ReportedPost.vue?vue&type=script&lang=js&"
import style0 from "./ReportedPost.vue?vue&type=style&index=0&id=f6c7639c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c7639c",
  null
  
)

export default component.exports